import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronDown, LogOut, User } from 'lucide-react';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';
import Dropdown, { MenuItem, MenuSeparator } from './ui/Dropdown';
import Avatar from './ui/Avatar';

const ProfileDropdown = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const fullName = [user?.first_name, user?.last_name].filter(Boolean).join(' ');

    const handleLogout = () => {
        logout();
        toast.success('Signed out');
        navigate('/login');
    };

    return (
        <Dropdown
            align="right"
            panelClassName="w-60"
            trigger={
                <button
                    type="button"
                    className="flex items-center gap-1.5 p-1 pr-1.5 rounded-md hover:bg-ink-100 transition-colors duration-150"
                    aria-label="Account menu"
                >
                    <Avatar name={fullName} size="md" />
                    <span className="hidden sm:block text-left leading-tight min-w-0">
                        <span className="block text-label font-medium text-ink-800 truncate max-w-[120px]">
                            {fullName || 'Account'}
                        </span>
                        <span className="block text-micro text-ink-500 truncate max-w-[120px]">
                            {user?.role}
                        </span>
                    </span>
                    <ChevronDown size={14} className="text-ink-400 shrink-0" aria-hidden="true" />
                </button>
            }
        >
            <div className="px-2.5 py-2">
                <p className="text-label font-semibold text-ink-900 truncate">{fullName}</p>
                <p className="text-micro text-ink-500 truncate">{user?.email}</p>
            </div>

            <MenuSeparator />

            <MenuItem as={Link} to="/profile" icon={User}>
                My profile
            </MenuItem>

            <MenuSeparator />

            <MenuItem icon={LogOut} danger onClick={handleLogout}>
                Sign out
            </MenuItem>
        </Dropdown>
    );
};

export default ProfileDropdown;
